import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Check } from 'lucide-react';
import SubpageShell from './SubpageShell';
import SEO from '../components/SEO';
import RainbowText from '../components/RainbowText';
import { SECTORS, sectorBySlug } from '../data/sectors';
import '../styles/RainbowText.css';
import '../styles/AboutV2.css';

const SectorPage = () => {
  const { slug } = useParams();
  const sector = sectorBySlug(slug);
  if (!sector) return <Navigate to="/about" replace />;
  const { img, label, Icon, lede, offers } = sector;
  const others = SECTORS.filter((s) => s.slug !== slug);

  return (
    <SubpageShell currentPath={`/sectors/${slug}`}>
      <SEO
        title={`${label} — Neuro-Inclusive Infrastructure`}
        description={`${lede} How N3URO WORLD® supports ${label.toLowerCase()}.`}
        path={`/sectors/${slug}`}
      />
      <section className="ab-section ab-sector" data-testid={`sector-page-${slug}`}>
        <Link to="/about" className="ab-sector-back" data-testid="sector-back"><ArrowLeft size={14} /> About · Connected ecosystem</Link>
        <div className="ab-sector-grid">
          <figure className="ab-sector-media page-hero-image">
            <img src={`/img/about/${img}.webp`} width="600" height="600" alt={label} loading="eager" decoding="async" fetchPriority="high" />
          </figure>
          <div>
            <span className="ab-eyebrow"><Icon size={14} aria-hidden="true" /> Sector</span>
            <h1 className="ab-h2" data-testid="sector-title"><RainbowText>{label}</RainbowText></h1>
            <p className="ab-body" data-testid="sector-lede">{lede}</p>
            <ul className="ab-sector-offers" data-testid="sector-offers">
              {offers.map((o) => (
                <li key={o}><Check size={16} strokeWidth={2.4} aria-hidden="true" />{o}</li>
              ))}
            </ul>
            <div className="ab-cta-row">
              <Link to="/infrastructure-enquiry" className="ab-btn-primary" data-testid="sector-partnership-cta">
                Start a partnership enquiry <ArrowRight size={16} strokeWidth={2.4} />
              </Link>
            </div>
          </div>
        </div>
        <nav className="ab-sector-others" aria-label="Other sectors">
          {others.map((s) => (
            <Link key={s.slug} to={`/sectors/${s.slug}`} data-testid={`sector-link-${s.slug}`}>{s.label}</Link>
          ))}
        </nav>
      </section>
    </SubpageShell>
  );
};

export default SectorPage;
